module.exports = __webpack_public_path__ + "img/3.c20e9d00.png";